import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    rollbackMessage: translate({ id: 'transactionBar.messages.rollbackMessage' }),
  }))

  return api
}
